"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconRecycleBin = function IconRecycleBin(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '48px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 48 48",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M21.511 5.107a5 5 0 0 0-6.878.186L5.11 14.896l-.182.191a5 5 0 0 0 .185 6.88l.019.019-.016.016.123.123-.866.866L.181 23a24 24 0 0 0 0 2l5.024-.01 1.451-1.452 15.8 15.765a5.502 5.502 0 0 0 8.933 6.086A5.48 5.48 0 0 0 33 41.415l9.708-9.708.147-.154c1.697-1.864.897-4.217-1.307-6.42L21.75 5.325l-.005.005-.042-.042zm-1.179 1.639-.04-.04a3 3 0 0 0-4.098-.137l-.144.135-9.523 9.604a3 3 0 0 0-.136 4.1l.136.145.017.017zm3.279 30.865-.01.01-15.53-15.497L21.894 8.299l18.238 18.248.171.175c1.444 1.507 1.807 2.753.989 3.57l-8.831 8.832a5.5 5.5 0 0 0-8.851-1.513m6.364 1.414a3.5 3.5 0 1 0-4.95 4.95 3.5 3.5 0 0 0 4.95-4.95m-3.536 1.414a1.5 1.5 0 1 0 2.122 2.122 1.5 1.5 0 0 0-2.122-2.122m.707.707a.5.5 0 1 1 .707.708.5.5 0 0 1-.707-.708m2.718-19.89 7.78 7.78-.707.707-7.78-7.78z",
    clipRule: "evenodd"
  })));
};

export { IconRecycleBin, IconRecycleBin as default };
